(() => {
  const sticky = document.querySelector('[data-sticky-buy]');
  const footer = document.querySelector('[data-site-footer]');
  if (sticky && footer && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-near-footer', entry.isIntersecting);
    }, { rootMargin: '0px 0px 90px 0px', threshold: 0 });
    observer.observe(footer);
  }
})();
